import { Button } from '@/shared/components';
import ExchangeRotateIcon from '@/shared/assets/exchange-rotate-icon.svg?react';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

const ExchangeRotateButton = ({ onClick, disabled }: Props) => {
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={onClick}
      disabled={disabled}
      className="size-[2.4rem] p-0 rounded-[0.8rem] border border-stroke bg-background text-foreground shadow-[0px_1px_4px_0px_rgba(0,0,0,0.04)] hover:bg-secondary-bg">
      <ExchangeRotateIcon className="size-[2rem]" />
    </Button>
  );
};

export { ExchangeRotateButton };
